module.exports = "/virtual-football-league/img/video/clubs/spain/atletico-madrid.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/clubs/spain/atletico-madrid.png
// module id = 354
// module chunks = 4